/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HourglassIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABqUlEQVR4nL1V20oDQQxdFfwT9ckLqCiir6J0J8kKu0n7GfUDKn2xRVA/wcu3iKD+hZcHC33V0kplZmft1goz2xYD89DZk5w5SZoEwX9bHMfzQNxUyG9A0vc5ivgVSBra10mggb6BYfQ0nAT2NX1E3vFVHVJ5N1Pio8C8xjd4YT+F0tPAOI7nnGBrGmsUoPScYCB50WAiXvQlAIiXUgJ+9iG4sfk89yVQKJcmRchXTnApSla1VIX8pUjKtVptFohbIx2D8h4EwYzGGCxKD7Gy7PUiIK7aQF2IEoFISlltsvuQ+NB80xhzx1VfxVY2nwwFIzkbEHDT3pngGlso+ECJ1G09HsMo2cwIiCrrivjJ/q6PFTxPACgPeQIA2ZiYIJ8iFcnB8AiZMEUK5ThfZJUSdKdSZMTKWtp2aZuGxPuA/DEyQVE6AAL5NlVKVpwEgHyb/dEAZOuv4LnzqaJkG4gvUh+59p6mpaPyAqDcu3eB3Omx4j0q8sPOpMFFgNIpOux+xi4Qt91Lhtu//bxSpJeIE2wNkfeKLJyxV6ZCOXUSpEtfGpmSqS/9ads3pT3NQE7d0PQAAAAASUVORK5CYII=)
 */
export const HourglassIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.1 8.85A.5.5 0 0 1 9.45 8h5.1a.5.5 0 0 1 .35.85l-.84.85a3.25 3.25 0 0 0 0 4.6l2.06 2.06A3 3 0 0 1 17 18.5v1.01a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1.01a3 3 0 0 1 .88-2.13l2.06-2.06a3.25 3.25 0 0 0 0-4.6l-.84-.85Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7 1a3 3 0 0 0-3 3v1.51a6 6 0 0 0 1.76 4.25l2.06 2.06c.1.1.1.26 0 .36l-2.06 2.06A6 6 0 0 0 4 18.5V20a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1.51a6 6 0 0 0-1.76-4.25l-2.06-2.06a.25.25 0 0 1 0-.36l2.06-2.06A6 6 0 0 0 20 5.5V4a3 3 0 0 0-3-3H7ZM6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.51a4 4 0 0 1-1.17 2.83l-2.07 2.07c-.88.88-.88 2.3 0 3.18l2.07 2.07A4 4 0 0 1 18 18.49V20a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1.51a4 4 0 0 1 1.17-2.83l2.07-2.07c.88-.88.88-2.3 0-3.18L7.17 8.34A4 4 0 0 1 6 5.51V4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
